import React from "react";
import {withStyles,Card,CardContent,CardHeader,CardActions,Button} from "@material-ui/core";
import icon from "../../assets/img/iSpani_Icon.jpeg"
import logo from "../../assets/img/iSpani_Logo.png"

import {Muted} from "../../components"


class HomePage extends React.Component{

    render(){
        const {classes,history,route} = this.props

        console.log("this.props:",this.props)

        return(
            <div className={classes.content}>
                <Card className={classes.card}>
                    <CardHeader>

                    </CardHeader>
                    <CardContent>
                        <div className={classes.content}>
                            <img src={logo} width="250"/>
                            <h2 className={classes.heading}>Welcome to the iSpani Dashboard</h2>
                            <p className={classes.subText}>Register and create an account or log in to an existing account.</p>
                        </div>
                    </CardContent>
                    <CardActions>
                        <div className={classes.buttonContainer}>
                        <Button variant="contained" className={classes.button} onClick={()=>{route.history.push("register")}} color="primary">Register</Button>
                        <Button variant="contained" className={classes.button} onClick={()=>{route.history.push("login")}}  color="primary">Log in</Button>
                        </div>
                    </CardActions>

                </Card>

            </div>
        )
    }
}

const styles={
    card:{
        maxWidth:800,
        marginTop:100,
        margin:"auto",
    },
    content:{
      display:"flex",
      flexDirection:"column",
      justifyContent:"center",
      alignItems:"center",
      marginLeft:100,
      marginRight:100

    },
    heading:{
      textAlign:"center",
      marginTop:0,
      marginBottom:0
    },
    button:{
      width:100,
      marginLeft:10,
      marginRight:10

    },
    buttonContainer:{
        display:"flex",
        justifyContent:"center",
        width:"100%",
        marginBottom:50
    },
    subText:{
        textAlign:"center",
        maxWidth:250,
        marginTop:0
    },
    root:{
      display:"flex",
      justifyContent:"center",

    }

}

export default withStyles(styles)(HomePage)


// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx